module.exports = __webpack_public_path__ + "static/img/073.6ec9f51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/lkpy/073.png
// module id = BxSE
// module chunks = 0